<template>
  <v-list 
    dense
    class="items-list"
  >
    <v-list-item 
      three-line
      v-for="item in cartItems"
      :key="item.id"
    >
      <v-list-item-content class="cart-item pb-5">

        <v-list-item-title>
          Référence {{ item.reference.name }} (x{{ item.quantity }}) - {{ item.getUnitPrice() * item.quantity | toPrice(2, '€HT') }}
          <v-icon
            class="float-right btn-delete"
            @click.prevent="removeFromCart(item)"
          >
            mdi-delete
          </v-icon>
        </v-list-item-title>

        <v-list-item-subtitle>
          Couleur : 
          <span 
            class="mini-chip" 
            :style="{backgroundColor: item.color.hexacode}"
          ></span> {{ item.color.name }}<br>
        </v-list-item-subtitle>

        <v-list-item-subtitle>
          Taille : {{ item.size.name }}
        </v-list-item-subtitle>

      </v-list-item-content>
    </v-list-item>
  </v-list>
</template>

<script>
  // EVENTS
  import { REMOVE_FROM_CART } from '@/store/actions/cart'
  //VUEX
  import { mapGetters } from 'vuex'

  export default {
    name: 'Items',

    computed: {
      ...mapGetters({
        cartItems: 'getItems',
      }),
    },

    methods: {
      removeFromCart(item) {
        this.$store.dispatch(REMOVE_FROM_CART, item)
      }
    },
  }
</script>

<style lang="scss" scoped>
  @import '@/styles/variables.scss';
  
  .btn-delete:hover {
    cursor: pointer;
    color: red;
  }
  .cart-item {
    border-bottom: 1px solid #e2e2e2;
  }
  .v-list-item__content {
    text-align: left;
  }
  .v-list--dense .v-list-item .v-list-item__title,
  .v-list--dense .v-list-item .v-list-item__subtitle {
    font-size: 1rem;
    line-height: 1.5rem;
  }
  .items-list {
    background: $primary-color;
    max-height: 40rem;
    overflow-y: scroll;
  }
  .items-list::-webkit-scrollbar {
    width: 5px;
  }
  .items-list::-webkit-scrollbar-track {
    background-color: #fff;
  }
  .items-list::-webkit-scrollbar-thumb {
    background: $primary-color;
    outline: 1px solid #654321;
    border-radius: 20px;
    width: 5px;
  }
  .mini-chip {
    display: inline-block;
    width: 10px;
    height: 10px;
    border: 1px solid #000;
    border-radius: 50%;
    margin-right: 1px;
    align-items: center;
    display: inline-flex;
    font-feature-settings: "liga";
    font-size: 24px;
    justify-content: center;
    letter-spacing: normal;
    line-height: 1;
    position: relative;
    text-indent: 0;
    transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1), visibility 0s;
    vertical-align: middle;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
</style>